// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkComponent_link__SahHp","icon":"LinkComponent_icon__7idw-"};